<template>
  <div class="agent-notice-management">
    <el-card shadow="never">
      <div class="card-title">上级通知</div>
      <p class="hint">确认内容后可一键发给全部下级用户，用户会在 App「消息」中看到。</p>
      <div v-if="error" class="error">{{ error }}</div>
      <el-table
        :data="records"
        border
        stripe
        v-loading="loading"
        element-loading-text="正在加载..."
        row-key="id"
      >
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="senderName" label="发送人" width="140" show-overflow-tooltip />
        <el-table-column prop="content" label="内容" min-width="280" show-overflow-tooltip />
        <el-table-column prop="createdAt" label="收到时间" width="180" align="center" />
        <el-table-column label="状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.forwarded" type="success" size="small">已转发</el-tag>
            <el-tag v-else type="warning" size="small">待转发</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="覆盖用户" width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.forwarded ? (scope.row.userCount || 0) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-s-promotion"
              :disabled="scope.row.forwarded"
              :loading="forwardingId === scope.row.id"
              @click="handleForward(scope.row)"
            >一键转发</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getAgentNoticeInbox, forwardNotice } from '@/api/notice'
import { getResponseMessage } from '@/utils/http'

export default {
  name: 'AgentNoticeManagement',
  data() {
    return {
      loading: false,
      error: '',
      records: [],
      forwardingId: null,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.fetchPage()
  },
  methods: {
    async fetchPage() {
      this.error = ''
      this.loading = true
      try {
        const result = await getAgentNoticeInbox({
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        })
        const data = result && result.data ? result.data : {}
        this.records = data.records || []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.error = e && e.message ? e.message : '加载失败'
        this.records = []
      } finally {
        this.loading = false
      }
    },
    async handleForward(row) {
      try {
        await this.$confirm('确认后将发送给全部下级用户，是否继续？', '一键转发', {
          confirmButtonText: '确认转发',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      this.forwardingId = row.id
      try {
        const result = await forwardNotice(row.id)
        const count = result && result.data != null ? result.data : 0
        this.$message.success(getResponseMessage(result, `已发送给 ${count} 名下级用户`))
        this.fetchPage()
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '转发失败')
      } finally {
        this.forwardingId = null
      }
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchPage()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchPage()
    }
  }
}
</script>

<style scoped>
.card-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}

.hint {
  color: #64748b;
  font-size: 13px;
  margin: 0 0 16px;
}

.error {
  color: #f87171;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
